import { Link } from "@caprikorn/dynamo-ui";
import { classNames } from "@caprikorn/dynamo-utils";

import { InfoItem } from "@components/InfoItem/InfoItem";
import { CLOSING_TARIFF_SHIELD_FORM_DATE } from "@core/core.constants";
import { CustomTrans } from "@utils/translations/CustomTrans";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import classes from "./ShieldLegalIntro.module.css";

const ELIGIBILITY_CRITERIA_LINK =
  "https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000048737185";
const POWER_SURGE_PROTECTOR_FAQ_LINK =
  "https://www.ecologie.gouv.fr/amortisseur-electricite-entreprises-et-collectivites-des-2023";
const POWER_SURGE_PROTECTOR_SIMULATOR_LINK =
  "https://www.impots.gouv.fr/simulateur-amortisseur-electricite";

export const ShieldLegalIntro = () => {
  const { t } = useCustomTranslation("main");

  return (
    <div className={classes.container}>
      <h1 className="font-title-xl">{t("shield.legalIntro.title")}</h1>
      <InfoItem
        name={t("shield.legalIntro.legalSources.generalLabel")}
        value={t("shield.legalIntro.legalSources.generalValue")}
      />
      <p>{t("shield.legalIntro.legalSources.decree")}</p>
      <InfoItem
        name={t("shield.legalIntro.legalSources.norLabel")}
        value={t("shield.legalIntro.legalSources.norValue")}
      />
      <ol className={classes.list}>
        <li>
          <p>{t("shield.legalIntro.legalSources.eligibilityCriteria")}</p>
          <Link
            href={ELIGIBILITY_CRITERIA_LINK}
            rel="noreferrer"
            target="_blank"
          >
            {ELIGIBILITY_CRITERIA_LINK}
          </Link>

          <p>{t("shield.legalIntro.legalSources.powerSurgeProtectorFaq")}</p>
          <Link
            href={POWER_SURGE_PROTECTOR_FAQ_LINK}
            rel="noreferrer"
            target="_blank"
          >
            {POWER_SURGE_PROTECTOR_FAQ_LINK}
          </Link>

          <p>
            {t("shield.legalIntro.legalSources.powerSurgeProtectorSimulator")}
          </p>
          <Link
            href={POWER_SURGE_PROTECTOR_SIMULATOR_LINK}
            rel="noreferrer"
            target="_blank"
          >
            {POWER_SURGE_PROTECTOR_SIMULATOR_LINK}
          </Link>
        </li>
        <li>
          <CustomTrans
            components={{
              span: <span className="font-body-highlight" />,
            }}
            i18nKey="shield.legalIntro.explanation"
            ns="main"
          />

          <p className={classNames(classes.error, "font-body-highlight")}>
            {t("shield.legalIntro.eligibilityWarning", {
              date: new Date(CLOSING_TARIFF_SHIELD_FORM_DATE),
            })}
          </p>
        </li>
        <li>
          <p className={classNames(classes.error, "font-body-highlight")}>
            {t("shield.legalIntro.willfulBreachWarning")}
          </p>
        </li>
      </ol>
    </div>
  );
};
